import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { Row, Table } from "antd";
import { toJS, runInAction, action } from "mobx";
import TableText from "../../table/TableText";
import { calculation } from "@/method";

const totalIndex = [];

@inject("store")
@observer
class App extends Component {
  @action
  onChange = (name, value, i) => {
    let data = toJS(this.props.store.kpifollow.comments);
    data[i][name] = value;
    this.props.store.kpifollow.comments = data;
  };

  render() {
    const { data, loading, comments } = this.props.store.kpifollow;
    const columns = [
      {
        title: "客房预订平台",
        dataIndex: `name`,
        key: `name`,
        width: 150,
        align: "center",
        render: (text, record, index) => {
          const props = {
            text,
            index,
            type: "text",
            name: `name`,
            onChange: this.onChange,
            totalIndex,
          };
          return <TableText data={props} />;
        },
      },
      {
        title: "MTD订单数",
        dataIndex: `order`,
        key: `order`,
        width: 150,
        align: "center",
        render: (text, record, index) => {
          const props = {
            text,
            index,
            type: "inputNumber",
            name: `order`,
            onChange: this.onChange,
            totalIndex,
          };
          return <TableText data={props} />;
        },
      },
      {
        title: "MTD点评数",
        dataIndex: `comment`,
        key: `comment`,
        width: 150,
        align: "center",
        render: (text, record, index) => {
          const props = {
            text,
            index,
            type: "inputNumber",
            name: `comment`,
            onChange: this.onChange,
            totalIndex,
          };
          return <TableText data={props} />;
        },
      },
      {
        title: "MTD分数",
        dataIndex: `fraction`,
        key: `fraction`,
        width: 150,
        align: "center",
        render: (text, record, index) => {
          const props = {
            text,
            index,
            type: "inputNumber",
            name: `fraction`,
            onChange: this.onChange,
            totalIndex,
          };
          return <TableText data={props} />;
        },
      },
      {
        title: "点评总分",
        dataIndex: `total`,
        key: `total`,
        width: 150,
        align: "center",
        render: (text, record, index) => {
          const props = {
            text,
            index,
            type: "inputNumber",
            name: `total`,
            onChange: this.onChange,
            totalIndex,
          };
          return <TableText data={props} />;
        },
      },
    ];

    return (
      <div className="" style={{ marginTop: 50 }}>
        <div>
          <Row className="secondary_title">网评数据</Row>
          <Table
            columns={columns}
            dataSource={toJS(comments)}
            size="middle"
            bordered
            pagination={false}
            className="content"
            rowKey={"r.name"}
          />
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/kpifollow/Table3.js